<template lang="pug">
  .category-panel-content(v-if="categoryContent.link==null")
    .promotion(v-if="categoryEntry")
      .promotion-title 主題推薦
      .entries
        .entry
          div(v-if="categoryContent.classfyBanner1.imageHtml!=null")
            div(v-html="categoryContent.classfyBanner1.imageHtml")
        .entry
          div(v-if="categoryContent.classfyBanner2.imageHtml!=null")
            div(v-html="categoryContent.classfyBanner2.imageHtml")
    .sub-categories
      .sub-categories-title 產品分類
      .wrapper
        .entry(v-for="(item,tid) in categoryContent.category",:key="'cata-'+tid")
          .block
            img(src="@/assets/img/preload_category_item.svg",v-if="item.imagePath == undefined")
            img(:src="item.imagePath",v-else)
            .title {{item.name}}
          a(:href="item.link")
</template>

<script>
export default {
  name: 'category-panel',
  props:{
    categoryContent: {
      type: Object,
      require: true,
      default: function(){
        return {}
      }
    },
    // activeTabNumber:{
    //   type: Number,
    //   require: true,
    //   default: function(){
    //     return 3000
    //   }
    // }
  },
  computed:{
    categoryEntry(){
      return null != this.categoryContent.classfyBanner1.imageHtml || null != this.categoryContent.classfyBanner2.imageHtml
    }
  },
  destroy(){

  }
}
</script>
